module.exports = __webpack_public_path__ + "img/page16.98cb1b20.jpg";